export const DIVERSITY_INDICATOR_TEXT_EN = '(a)';
export const DIVERSITY_INDICATOR_TEXT_DE = '(a)';
export const DIVERSITY_INDICATOR_TEXT_FR = '(f/h/d)';
export const DIVERSITY_INDICATOR_TEXT_ES = '(f/m/d)';
